import * as React from 'react';
import styled from 'styled-components';

import { JRCFolder } from './JRCFolder';
import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import { JRCEllipsis } from 'components/JRCEllipsis/JRCEllipsis';

import Theme from 'styles/theme';
import { EntryType } from './JRCFolders';

const BreadcrumbWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin: 10px 0;
`;

const BreadcrumbEntry = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 10px;
    width: fit-content;
`;

const BreadcrumbSeparator = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
`;

const TitleValue = styled.div`
    align-items: center;
    display: flex;
`;

const JRCFolderBreadcrumb = ({
    entries = [],
    onPress,
}: {
    entries: EntryType[];
    onPress: (entry: EntryType) => void;
}) => {
    if (!entries.length) {
        return <></>;
    }

    const SMALL_DISPLAY = entries.length > 4;

    const DISPLAY_ENTRIES = entries.map((entry, index) => {
        const DISPLAY_SEPARATOR =
            index < entries.length - 1 ? (
                <BreadcrumbSeparator>
                    <JRCIcon name="icon-angle-right" size={10} color={'#989898'} />
                </BreadcrumbSeparator>
            ) : (
                <></>
            );

        return entry.type === 'folder' || entry.type === 'rootFolder' ? (
            <BreadcrumbEntry key={entry.uri} onClick={() => onPress(entry)}>
                <JRCFolder
                    color={'folderColor' in entry && entry.folderColor ? entry.folderColor : Theme.get().color.grey3}
                    size={'sm'}></JRCFolder>
                <TitleValue>
                    <JRCEllipsis label={entry.title} length={!SMALL_DISPLAY ? 20 : 4}></JRCEllipsis>
                </TitleValue>
                {DISPLAY_SEPARATOR}
            </BreadcrumbEntry>
        ) : (
            <TitleValue key={entry.uri}>
                <JRCEllipsis label={entry.title} length={SMALL_DISPLAY ? 4 : 20}></JRCEllipsis>
            </TitleValue>
        );
    });

    return <BreadcrumbWrapper>{DISPLAY_ENTRIES}</BreadcrumbWrapper>;
};

export { JRCFolderBreadcrumb };
